import { render, staticRenderFns } from "./SupplierBrand.vue?vue&type=template&id=6899604a&scoped=true&"
import script from "./SupplierBrand.vue?vue&type=script&lang=js&"
export * from "./SupplierBrand.vue?vue&type=script&lang=js&"
import style0 from "./SupplierBrand.vue?vue&type=style&index=0&id=6899604a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6899604a",
  null
  
)

export default component.exports